import { useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.tsx';
import { gql } from '@/__generated__';
import { StreamSubscriptionCancelInput } from '@/__generated__/graphql.ts';

const CancelStreamSubscription = gql(`
  mutation CancelStreamSubscription($input: StreamSubscriptionCancelInput!) {
    streamSubscriptionCancel(input: $input) {
      cancelAt
    }
  }
`);

export const useCancelStreamSubscription = (streamId: string) => {
  const toast = useToast();

  const [cancelStreamSubscriptionMutation, result] = useMutation(
    CancelStreamSubscription,
    {
      onError: () => {
        toast.error({
          title: 'Failed to cancel subscription',
          subTitle: 'Please try again',
        });
      },

      update(cache, result) {
        const cancelAt = result.data?.streamSubscriptionCancel.cancelAt;
        if (cancelAt) {
          cache.modify({
            id: `Stream:${streamId}`,
            fields: {
              subscription: () => {
                return { cancelAt };
              },
            },
          });
        }
      },
    },
  );

  const cancelStreamSubscription = (input: StreamSubscriptionCancelInput) => {
    return cancelStreamSubscriptionMutation({
      variables: {
        input,
      },
    });
  };

  return [cancelStreamSubscription, result] as const;
};
